<div class="enhancement-item">
  <div class="details">
    <h2>{{ enhancement.name }}</h2>
    <p>{{ enhancement.description }}</p>
    <p>Price: {{ enhancement.price | currency:'GBP' }}</p>
  </div>
  <div class="img">
    <img [src]="enhancement.image" alt="{{ enhancement.name }} image" />
  </div>
</div>
